var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 6.944a1.11 1.11 0 0 0-1.111-1.11H15v.833h1.389c.153 0 .278.125.278.277v.034l.002.033.83 10.233a.28.28 0 0 1-.277.256H2.778a.277.277 0 0 1-.277-.256l.83-10.233.002-.033v-.034c0-.152.125-.277.278-.277h1.39v-.834H3.61a1.11 1.11 0 0 0-1.11 1.111l-.834 10.278a1.11 1.11 0 0 0 1.11 1.111h14.445a1.11 1.11 0 0 0 1.111-1.11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.946 2.888A4.16 4.16 0 0 0 9.9 1.667c-2.276.052-4.067 1.973-4.067 4.25v4.498a.416.416 0 1 0 .834 0v-3.75h6.666v3.75a.416.416 0 1 0 .834 0V5.833c0-1.15-.467-2.191-1.221-2.945m-6.28 2.945A3.34 3.34 0 0 1 10 2.5a3.34 3.34 0 0 1 3.333 3.333z"
  })));
};
export default SvgShoppingBag;